<div class="ql-char-count" [ngClass]="{ 'text-red-600': charCount >= maxLength }" *ngIf="maxLength">{{ charCount }} / {{ maxLength }}</div>
<quill-editor
  class="ql-container w-full"
  [attr.data-test-id]="'editor-' + formControlName"
  [ngModel]="initValue"
  [placeholder]="placeholder"
  [readOnly]="isDisabled"
  [modules]="editorModules"
  [maxLength]="maxLength"
  (onContentChanged)="editorInput($event)"
  (onBlur)="editorBlur()"
  (onEditorCreated)="editorCreated($event)"
  (input)="onInputChange()"
>
</quill-editor>
